import React, { Component } from 'react';
import { connect } from 'react-redux';
import TripMenu from './TripMenu';
import CoverPhoto from '../utility/CoverPhoto';
import TripInfo from './TripInfo';
import TourGuide from './TourGuide';
import Itinerary from './Itinerary';
import NewItinerary from './NewItinerary';
import ItemList from './ItemList';
import OtherTrips from './OtherTrips';
import ContentBlock from './ContentBlock';
import AdditionalInfo from './AdditionalInfo';
import MeetingPoints from './MeetingPoints';
import TermsAndConditions from '../TermsAndConditions';
import Button from '../utility/Button';
import KeepMeInform from './KeepMeInform';
import PhotoGallery from './PhotoGallery';
import PropTypes from 'prop-types';
import ErrorDisplay from '../utility/ErrorDisplay';
import LottieLoader from '../utility/LottieLoader';
import ReviewList from '../Reviews/ReviewList';
import CopyButton from '../utility/CopyButton';
import TripTnc from './TripTnc';
import { SDAC_EMAIL, difficultyName } from '../../constants';
import { mailto, findMinMaxPaxRate } from '../../js/utility';


import {
  FacebookShareButton,
  TwitterShareButton,
  WhatsappShareButton
} from 'react-share';

import { FacebookIcon, XIcon, WhatsappIcon } from 'react-share';

import {
  getPricePerPax,
  getPriceByPax,
  getDiscPricePerPax,
  createDiscountLabel,
  createPriceLabel,
  formatVendorName
} from '../../js/utility';

import ShareButton from '../utility/ShareButton';
import { withTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';

import { clearApiError } from '../../actions/api';

import { fetchTripDetails } from '../../actions/tripDetails';

import {
  setBookingAvailDates,
  setBookingUnavailDates,
  setBookingPax,
  setBookingDate
} from '../../actions/booking';

import { SITE_TITLE } from '../../constants';

import iconLocation from '../../images/icons/icon_32_location.png';
import iconPrice from '../../images/icons/icon_32_price.png';
import iconDuration from '../../images/icons/icon_32_duration.png';
import iconStar from '../../images/icons/icon_32_star.png';
import iconPax from '../../images/icons/icon_32_noofpax.png';

// IMPORT REVAMP PAST EXP TRIP DETAILS PAGE
import navIcon from '../../images/icons/NavIcon.png';
import pillCoin from '../../images/icons/pillCoin.png';
import pillInnerRing from '../../images/pillInnerRing.png';
import pillOuterRing from '../../images/pillOuterRing2.png';
import pillPaxIcon from '../../images/icons/pillPaxIcon.png';
import pillCarIcon from '../../images/icons/pillCarIcon.png';
import pillCalendar from '../../images/icons/pillCalendar.png';
import thankYouGradient from '../../images/ThankyouGradient_v2.png';
import thankYouGradientMobile from '../../images/ThankyouGradientMobile_v2.png';
import bluePill from '../../images/Blue_Pill.png';
import pillMobileBG from '../../images/pillMobileBG.png';
import pillBlueTag from '../../images/pillBlueTag.png';
// import pillWhiteTag from '../../images/pillWhiteTagLonger.png';
import pillWhiteTag from '../../images/pillWhiteTagLonger_v2.png';
import pillWhiteBlurb from '../../images/pillWhiteBlurb.png';
import BGBookNow from '../../images/BG_Book_Now.png';
// IMPORT REVAMP PAST EXP TRIP DETAILS PAGE - END

import Keep_Me_UpdateButtonHover from '../../images/Keep_Me_Updated_Button_Hover.png';
import Keep_Me_Updated_Button from '../../images/Keep_Me_Updated_Button.png';
import Reserve_A_SpotButtonHover from '../../images/Reserve_A_Spot_Button_Hover.png';
import Reserve_A_Spot_Button from '../../images/Reserve_A_Spot_Button.png';

class TripDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      initData: false, //Ensures we have pre-populated booking pax / date before rendering menu
      showMobMenu: false,
      showPopupKmi: false,
      showPopupVideo: false,
      showPopupCalendar: false,
      isAdditionalScrollable: false,
      selectedAdditionalInfo: -1,
      videoUrl: '',
    };
    this.onMenuClose = this.onMenuClose.bind(this);
    this.initData = this.initData.bind(this);
    this.togglePopUpKmi = this.togglePopUpKmi.bind(this);
    this.togglePopUpVideo = this.togglePopUpVideo.bind(this);
    this.togglePopUpCalendar = this.togglePopUpCalendar.bind(this);
    this.onSelectInfo = this.onSelectInfo.bind(this);
    this.onCheckScrollable = this.onCheckScrollable.bind(this);
    this.getYoutubeID = this.getYoutubeID.bind(this);
  }

  componentDidMount() {
    this._isMounted = true;
    this.props.clearApiError();
    this.initData();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.initData();
    }
  }

  togglePopUpKmi(val){
    this.setState({showPopupKmi: val});
  }

  togglePopUpVideo(val, url){
    if (url){
      this.setState({videoUrl: url});
    }
    else{
      this.setState({videoUrl: ''});
    }
    this.setState({togglePopUpVideo: val});
  }

  togglePopUpCalendar(val){
    this.setState({showPopupCalendar: val});
  }

  onMenuClose(){
    this.setState({ showMobMenu: false });
  }

  onSelectInfo(index){
    this.setState({selectedAdditionalInfo: index});
    this.onCheckScrollable();
  }

  onCheckScrollable(){
    setTimeout(() => {
      if (this.additionalDisplay){
        let newScrollableCheck = false;
        newScrollableCheck = this.additionalDisplay.scrollHeight > this.additionalDisplay.clientHeight;
        this.setState({isAdditionalScrollable: newScrollableCheck});
      }
    },500);
  }

  getYoutubeID(url){
    if(url){
      var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
      var match = url.match(regExp);

      if (match && match[2].length == 11) {
        return match[2];
      } else {
        console.log("Unable to process Youtube URL: ", url);
        return 'error';
      }
    }
  }

  async initData() {

    // check if back from booking
    const params = new URLSearchParams(this.props.location.search);
    if (params.get('back')){
      this.setState({ showMobMenu: true });
    }

    // bar
    const slug = this.props.match.params.slug;
    const { fetchTripDetails } = this.props;
    await fetchTripDetails(slug);
    const { error } = this.props;
    if (!error && this._isMounted) {
      const { currentTrip } = this.props;

      // create new current pax_max
      currentTrip.pax.current_pax_max = currentTrip.pax.pax_max;

      if (currentTrip.available_slot.length){

        // Checking if trip is daily trip or custom date trip
        let slotDates = Object.keys(currentTrip.available_slot[0]);
        if (slotDates.length && !currentTrip.available_dates.length){

          // Remove empty slot or slot lower then minimum_slot_rate
          slotDates.forEach(slot => {
            if ((currentTrip.available_slot[0][slot] === 0) || currentTrip.available_slot[0][slot] < currentTrip.pax.pax_min || currentTrip.available_slot[0][slot] < findMinMaxPaxRate(currentTrip.trip_price.adult_rate, 'min')){
              delete currentTrip.available_slot[0][slot];
            }
          });
          slotDates = Object.keys(currentTrip.available_slot[0]);

          if (currentTrip.advance_booking !== 0){
            // Define earliest date based on advance_booking
            const earliest_Date = new Date();
            earliest_Date.setDate(new Date().getDate() + currentTrip.advance_booking);
            // Remove dates that less than earliest date
            slotDates.forEach(slot => {
              if (new Date(slot) < earliest_Date){
                delete currentTrip.available_slot[0][slot];
              }
            });
          }
          else{
            // Allow booking until 11.59pm before same date with slot
            const now_date = new Date();
            slotDates.forEach(slot => {
              const slot_date = new Date(slot);
              slot_date.setDate(slot_date.getDate() - 1);
              slot_date.setHours(23,59);
              if (now_date >= slot_date){
                delete currentTrip.available_slot[0][slot];
              }
            });
          }

          slotDates = Object.keys(currentTrip.available_slot[0]);
          currentTrip.available_dates = slotDates;

          // recheck for max pax based on slot available
          if (currentTrip.available_slot[0][slotDates[0]] < currentTrip.pax.current_pax_max){
            currentTrip.pax.current_pax_max = parseInt(currentTrip.available_slot[0][slotDates[0]]);
          }
        }
        else{

          // Remove all dates if total slot empty or lower then minimum_slot_rate
          if ( (currentTrip.total_available_slot === 0) || currentTrip.total_available_slot < currentTrip.pax.pax_min || currentTrip.total_available_slot < findMinMaxPaxRate(currentTrip.trip_price.adult_rate, 'min')){
            currentTrip.available_dates = [];
          }

          // recheck for max pax based on slot available
          if ((currentTrip.total_available_slot !== null) && (currentTrip.total_available_slot < currentTrip.pax.current_pax_max)){
            currentTrip.pax.current_pax_max = currentTrip.total_available_slot;
          }
        }
      }
      const availDates = currentTrip.available_dates;
      const unavailDates = currentTrip.unavailable_dates;
      const initialDate = availDates[0];
      //const initialPax = currentTrip.pax.pax_min;
      this.props.setBookingAvailDates(availDates);
      this.props.setBookingUnavailDates(unavailDates);
      this.props.setBookingDate(initialDate);


      // set default pax to max
      // if (currentTrip.pax.current_pax_max > findMinMaxPaxRate(currentTrip.trip_price.adult_rate, 'max')){
      //   this.props.setBookingPax(findMinMaxPaxRate(currentTrip.trip_price.adult_rate, 'max'));
      // }
      // else{
      //   this.props.setBookingPax(currentTrip.pax.current_pax_max);
      // }

      // set default pax to min
      this.props.setBookingPax(currentTrip.pax.pax_min);

      this.setState({
        initData: true
      });
    }
  }

  render() {
    const { initData, showMobMenu } = this.state;
    const { loading, error } = this.props;

    if (error) {
      return <ErrorDisplay error={error} />;
    }

    if (loading || !initData) {
      return <LottieLoader />;
    }

    const slug = this.props.match.params.slug;


    this.props.location.pathname = '/getaways' + this.props.location.pathname;

    const { currentTrip, t, byorSelected } = this.props;
    const tripDiscount = currentTrip.trip_discount;

    // itinerary data process
    console.log('currentTrip', currentTrip);
    const itineraryDays = [...new Set(currentTrip.itinerary.map(item => item.day_no))];
    const finalItinerary = [];

    if (itineraryDays.length > 1){
      itineraryDays.map((day) => {
        if (day !== null){
          const activities = [];
          currentTrip.itinerary.map((activity) => {
            const images = [];
            if (activity.day_no === day){
              if(activity.medias){
                activity.medias.map((media) => {
                  if(media.media_type === 'image'){
                    images.push(media);
                  }
                });
                activity.images = images;
                activity.medias.map((media, index) => {
                  if(media.media_type === 'url'){
                    activity.images[index].youtubeUrl = media.youtube_url;
                  }
                });
              }
              activities.push(activity);
            }
          });
          finalItinerary.push(activities);
        }
      });
    }
    else{
      const activities = [];
      currentTrip.itinerary.map((activity) => {
        const images = [];
        if(activity.medias){
          activity.medias.map((media) => {
            if(media.media_type === 'image'){
              images.push(media);
            }
          });
          activity.images = images;
          activity.medias.map((media, index) => {
            if(media.media_type === 'url'){
              activity.images[index].youtubeUrl = media.youtube_url;
            }
          });
        }
        activities.push(activity);
      });
      finalItinerary.push(activities);
    }

    // setup additional info array
    const additionalInfoArray = [];
    if (currentTrip.items_to_bring && currentTrip.items_to_bring.length > 0 && currentTrip.items_to_bring[0] !== null){
      if (this.state.selectedAdditionalInfo === -1){
        this.setState({selectedAdditionalInfo: 0});
        this.onCheckScrollable();
      }
      additionalInfoArray.push({data: currentTrip.items_to_bring, title: t('trip:whatToBring')});
    }
    if (currentTrip.whats_included && currentTrip.whats_included.length > 0 && currentTrip.whats_included[0] !== null){
      if (this.state.selectedAdditionalInfo === -1){
        this.setState({selectedAdditionalInfo: 0});
        this.onCheckScrollable();
      }
      additionalInfoArray.push({data: currentTrip.whats_included, title: t('trip:whatsIncluded')});
    }
    if (currentTrip.additional_information && currentTrip.additional_information.length > 0 && currentTrip.additional_information[0].subject !== null){
      if (this.state.selectedAdditionalInfo === -1){
        this.setState({selectedAdditionalInfo: 0});
        this.onCheckScrollable();
      }
      additionalInfoArray.push({data: currentTrip.additional_information, title: t('trip:additionalInfo')});
    }
    if (currentTrip.cancellation_policy){
      if (this.state.selectedAdditionalInfo === -1){
        this.setState({selectedAdditionalInfo: 0});
        this.onCheckScrollable();
      }
      additionalInfoArray.push({data: currentTrip.cancellation_policy, title: t('trip:cancellationPolicy')});
    }

    const isByAge = currentTrip.trip_price.price_type === 'by_age';
    const isPerTrip = currentTrip.trip_price.is_per_trip;
    const isByPax = currentTrip.trip_price.price_type === 'by_pax';

    const pricePerPax = getPricePerPax(currentTrip.trip_price, {
      pax_max: currentTrip.pax.pax_max
    });
    const discPricePerPax = getDiscPricePerPax(
      currentTrip.trip_price,
      { pax_max: currentTrip.pax.pax_max },
      currentTrip.trip_discount
    );

    const lowestAdultPax = findMinMaxPaxRate(currentTrip.trip_price.adult_rate, 'min');

    // Include insurance, SST, & service fee
    const insurance = parseFloat(process.env.INSURANCE_AMOUNT);
    const sstPercentage = parseFloat(process.env.TAX_PERCENTAGE)/100;
    const serviceFee = parseFloat(process.env.SST_PERCENTAGE)/100;
    pricePerPax.adult = pricePerPax.adult + (insurance * lowestAdultPax);
    pricePerPax.adult = pricePerPax.adult + (pricePerPax.adult * serviceFee);
    pricePerPax.adult = pricePerPax.adult + (pricePerPax.adult * sstPercentage);

    let priceStr = createPriceLabel(pricePerPax, discPricePerPax);
    let discountStr = createDiscountLabel(currentTrip.trip_discount);
    let newPriceStr = createPriceLabel(pricePerPax, discPricePerPax);

    if (currentTrip.slug === 'ford-ranger-training-experience-sabah'){
      priceStr = 'From ' + priceStr.adult;
      newPriceStr = 'From ' + newPriceStr.adult;
    } else if (currentTrip.slug === 'off-roading-durian-adventure' || currentTrip.slug === 'advanced-4wd-adventure-off-road-course-at-m4trec-morning-session'){
      priceStr = priceStr.adult;
      newPriceStr = newPriceStr.adult;
    } else if (isPerTrip) {
      priceStr = t('gen:pricePerTrip', {
        price: priceStr
      });
    } else if (isByAge) {
      priceStr = t('gen:fromPricePerPax', {
        price: priceStr.adult
      }).concat('**');
    } else if (isByPax) {
      priceStr = t('gen:fromPriceByPax', {
        price: priceStr.adult,
        minPax: currentTrip.pax.pax_min
      });
      newPriceStr = t('gen:fromPrice', {
        price: newPriceStr.adult,
        minPax: currentTrip.pax.pax_min
      });
    } else {
      priceStr = t(
        `gen:${currentTrip.pax_min > 1 ? 'fromPricePerPax' : 'pricePerPax'}`,
        {
          price: priceStr
        }
      ).concat(currentTrip.pax_min > 1 ? '*' : '');
      newPriceStr = t(
        'gen:fromPrice',
        {
          price: newPriceStr
        }
      ).concat(currentTrip.pax_min > 1 ? '*' : '');
    }

    return (
      <>
        <Helmet>
          <title>
            {currentTrip.title} | {SITE_TITLE}
          </title>
        </Helmet>

        {((!currentTrip.display_exp && !currentTrip.upcoming && !currentTrip.fully_book)) ? (
        <>
          {/* Book Now Float Button */}
          <button onClick={() => this.togglePopUpCalendar(!this.state.showPopupCalendar)} className='fe-float-book-now'>
            BOOK NOW
          </button>

          {/* TripMenu Calendar Popup */}
          <div
            className={`fe-overlay calendar-popup ${(this.state.showPopupCalendar) ? ' show' : ''}`}
            onClick={() => this.togglePopUpCalendar(false)}
          >
            <div onClick={(e) => e.stopPropagation() }
              className={`fe-calendar-popup-container ${(this.state.showPopupCalendar) ? ' show' : ''}`}
              tabIndex='0'
            >
              {(!currentTrip.upcoming && !currentTrip.fully_book) ? <TripMenu /> : null}
            </div>
          </div>
        </>
        ) : null}

        {/* KMI Popup */}
        <div
          className={`fe-overlay kmi-popup ${(this.state.showPopupKmi) ? ' show' : ''}`}
          onClick={() => this.togglePopUpKmi(false)}
        />
        <div
          className={`fe-kmi-popup-container ${(this.state.showPopupKmi) ? ' show' : ''}`}
          tabIndex='0'
        >
          <KeepMeInform preferredTrip={currentTrip.title} togglePopUpKmi={this.togglePopUpKmi}/>
        </div>

        {/* Youtube Popup */}
        <div
          className={`fe-overlay video-popup ${(this.state.togglePopUpVideo) ? ' show' : ''}`}
          onClick={() => this.togglePopUpVideo(false)}
        />
        <div
          className={`fe-video-popup-container ${(this.state.togglePopUpVideo) ? ' show' : ''}`}
          tabIndex='0'
        >
          <div className="video-responsive">
            <iframe
              width='853'
              height='480'
              src={'//www.youtube.com/embed/' + this.getYoutubeID(this.state.videoUrl)}
              allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
              allowFullScreen
              title='Embedded youtube'
            />
          </div>
        </div>

        {/* {(currentTrip.display_exp || currentTrip.slug === 'tame-the-skies-and-clouds-by-being-a-pilot-for-a-day') ? ( */}
          <div className='fe-trip-info-container fe-past-experience fe-under-header-effect'>
            {(!currentTrip.display_exp && !currentTrip.upcoming && !currentTrip.fully_book) ? (
              <div className={'fe-trip-button-container' + (showMobMenu?' hide-book-now':'')}>
                <Button className={showMobMenu?' hide-book-now':''}
                  onClick={() => {
                    this.setState({ showMobMenu: true });
                  }}
                >
                  {t('gen:bookNow')}
                </Button>
                {(!currentTrip.upcoming && !currentTrip.fully_book) ? <TripMenu isMobile isActive={showMobMenu} btnText={'gen:next'} onMenuClose={this.onMenuClose} /> : null}
              </div>) : null}
            <CoverPhoto
              mobileUrl={currentTrip.photo_cover.mobile_view}
              desktopUrl={currentTrip.photo_cover.desktop_view}
              // mobileUrl='https://shop.sdacford.com.my/images/trips/e0659c76-115d-4dc7-881c-57b77fab1bf1/ahx5fj85r.jpeg'
              // desktopUrl='https://shop.sdacford.com.my/images/trips/e0659c76-115d-4dc7-881c-57b77fab1bf1/svru3lqf8.jpeg'
              togglePopUpVideo = {this.togglePopUpVideo}
              videoUrl = {currentTrip.video_url}
              isVideoExist = {(currentTrip.video_url !== null && currentTrip.video_url !== '')}
            />
            <div className='fe-blue-pill'>
              <div className='container'>
                <div className='fe-pill-main-div'>
                  {(currentTrip.display_exp) || (currentTrip.upcoming) || (currentTrip.fully_book) ? (
                  <>
                    <button className='fe-pill-kmi-button' onClick={() => this.togglePopUpKmi(true)}>
                    </button>
                  </>
                  ) : null}
                  <div className='fe-pill-left-div'>
                    <div className='fe-pill-title'>
                      {currentTrip.title}
                    </div>
                    <div className='fe-pill-company'>
                      {(currentTrip.vendor === 'Ice Age Event Management Sdn Bhd' || currentTrip.vendor === 'IPG Mediabrands') ? null : (`${currentTrip.vendor} (${currentTrip.vendor_no})`)}
                    </div>
                    <div className='fe-pill-location'>
                      <img className='fe-pill-icon' src={navIcon}/>
                      <span className='fe-pill-location-text'>
                        {currentTrip.location}
                      </span>
                    </div>
                  </div>
                  <div className='fe-pill-right-div'>
                    <div className='fe-main-box'>
                      <div className='fe-outer-circle'>
                        <div className='fe-inner-circle'>
                          <img src={(currentTrip.slug === 'ford-ranger-training-experience-sabah') ? pillCarIcon : pillPaxIcon} className='fe-pax-icon'/>
                          <span className='fe-pax-text'>
                            {`${(currentTrip.slug === 'ford-ranger-training-experience-sabah') ? 'per vehicle' :
                              (currentTrip.slug === 'off-roading-durian-adventure' || currentTrip.slug === 'advanced-4wd-adventure-off-road-course-at-m4trec-morning-session') ?
                                '' : currentTrip.pax.pax_no + ' pax'}`
                            }
                          </span>
                        </div>
                      </div>

                      <div className='fe-blue-tag'>
                        <img src={pillCalendar} className='fe-pax-icon'/>
                        <span>{currentTrip.duration}</span>
                      </div>
                      <div className='fe-white-tag'>
                        <img src={pillCoin} className='fe-pax-icon'/>
                        {currentTrip.slug !== 'ford-ranger-training-experience-sabah' || !currentTrip.upcoming || !currentTrip.fully_book ?
                          (
                            <span
                              dangerouslySetInnerHTML={{
                                __html: newPriceStr
                              }}
                            />
                          ) : (
                            <span className='to-confirm'>
                              Price to be confirmed
                            </span>
                          )
                        }
                      </div>
                      {(currentTrip.slug === 'off-roading-durian-adventure' || currentTrip.slug === 'advanced-4wd-adventure-off-road-course-at-m4trec-morning-session') ? '' : ((currentTrip.slug === 'sunrise-cameron-highlands' || (currentTrip.slug === 'a-trip-through-nature-at-gunung-jerai' || currentTrip.slug === 'a-trip-through-nature-at-gunung-jerai-individual')) ?
                        (
                          <div className='fe-white-blurb cameron'>
                            <span>{`Up to ${currentTrip.pax.pax_max} pax per vehicle only`}</span>
                          </div>
                        ):
                        (
                          <div className='fe-white-blurb'>
                            <span>{`Available up to ${currentTrip.pax.pax_max} pax`}</span>
                          </div>
                        )
                      )}
                      {(currentTrip.slug === 'sunrise-cameron-highlands' || (currentTrip.slug === 'a-trip-through-nature-at-gunung-jerai' || currentTrip.slug === 'a-trip-through-nature-at-gunung-jerai-individual')) ? (
                        <div className='fe-second-white-blurb'>
                          <span>{'Free for children 16 years old and below'}</span>
                        </div>
                      ) : ''}
                    </div>
                  </div>

                </div>
              </div>
            </div>

            <div className='fe-trip-share-btns'>
              <div className='container'>
                <div className='row'>
                  {/* <div className='col-lg-8'> */}
                  <div className='fe-trip-share-btns-container'>
                    <div className='fe-trip-share-text'>
                      {t('gen:shareTo')}:
                    </div>
                    <FacebookShareButton
                      url={`${process.env.APP_URL}${
                        this.props.location.pathname
                      }`}
                      quote={currentTrip.title}
                      className='fe-trip-share-text'
                    >
                      <ShareButton color='#0965FE'>
                        <FacebookIcon
                          size={32}
                          iconBgStyle={{ background: 'none' }}
                        />
                      </ShareButton>
                    </FacebookShareButton>
                    <TwitterShareButton
                      url={`${process.env.APP_URL}${
                        this.props.location.pathname
                      }`}
                      title={currentTrip.title}
                      className='fe-trip-share-text'
                    >
                      <ShareButton color='#000000'>
                        <XIcon
                          size={32}
                          iconBgStyle={{ background: 'none' }}
                        />
                      </ShareButton>
                    </TwitterShareButton>
                    <WhatsappShareButton
                      url={`${process.env.APP_URL}${
                        this.props.location.pathname
                      }`}
                      title={currentTrip.title}
                      className='fe-trip-share-text'
                    >
                      <ShareButton color='#25D366'>
                        <WhatsappIcon
                          size={32}
                          iconBgStyle={{ background: 'none' }}
                        />
                      </ShareButton>
                    </WhatsappShareButton>
                    <CopyButton className='fe-trip-share-text'/>
                  </div>
                </div>
                {/* </div> */}
              </div>
            </div>

            <div className='fe-trip-info'>
              <div className='container'>
                <div className='row position-relative'>
                  {/* <div className='col-lg-8'> */}
                  {currentTrip.description !== '' ? (
                    <div
                      className='fe-trip-main-desc'
                      dangerouslySetInnerHTML={{
                        __html: currentTrip.description
                      }}
                    />
                  ) : null}
                  {(slug === 'island-retreat-in-mantanani' || slug === 'beach-clean-up') ? null : (
                    <div className='fe-trip-main-disclamer'>
                      {(currentTrip.slug === 'tabin-wildlife-safari-adventure' || currentTrip.slug === 'marine-life-of-mabul' || currentTrip.slug === 'escape-to-kapalai-paradise') ? <p>{t('gen:disclamerBookWithFordMalaysia')}</p> : (currentTrip.title == 'Ford Ranger Raptor Sepang Experience'? <p>{t('gen:disclamerRaptor')}</p> : <p>{t('gen:disclamer')}</p>)}
                    </div>
                  )}
                  {/* </div> */}
                </div>
              </div>
            </div>


            {!currentTrip.display_exp && currentTrip.itinerary && currentTrip.itinerary.length > 0 ? (
              <NewItinerary
                itinerary={finalItinerary}
                theme={currentTrip.theme}
                sidePhotos={
                  currentTrip.photo_gallery.length >= 2
                    ? currentTrip.photo_gallery.filter(
                      photo => photo.is_featured === true
                    )
                    : []
                }
                galleryPrefix={slug}
                byorSelected={byorSelected}
                togglePopUpVideo = {this.togglePopUpVideo}
              />
            ) : null}

            {(this.state.selectedAdditionalInfo === -1 || currentTrip.display_exp) ? null : (
              <div className='fe-trip-additional-info'>
                <div className='container'>
                  <div className='fe-trip-add-info-box'>
                    <div className='fe-trip-add-info-menu'>
                      <div className='fe-shadow-box'>
                        {additionalInfoArray.map((info, x) => (
                          <div key={x} onClick={() => this.onSelectInfo(x)} className={`fe-trip-add-info-menu-item ${(x === this.state.selectedAdditionalInfo) ? 'selected' : '' }`}>
                            {info.title}
                          </div>
                        ))}
                      </div>
                    </div>
                    <div className='fe-trip-add-info-display fe-scrollbar' ref={additionalDisplay => (this.additionalDisplay = additionalDisplay)}>
                      {(t('trip:whatToBring') === additionalInfoArray[this.state.selectedAdditionalInfo].title) ? (
                        <ItemList
                          // title={t('trip:whatToBring')}
                          items={currentTrip.items_to_bring}
                          isScrollable={this.state.isAdditionalScrollable}
                        />
                      ) : null}
                      {(t('trip:whatsIncluded') === additionalInfoArray[this.state.selectedAdditionalInfo].title) ? (
                        <ItemList
                          // title={t('trip:whatsIncluded')}
                          items={currentTrip.whats_included}
                          isScrollable={this.state.isAdditionalScrollable}
                        />
                      ) : null}
                      {(t('trip:additionalInfo') === additionalInfoArray[this.state.selectedAdditionalInfo].title) ? (
                        <AdditionalInfo
                          additionalInfo={currentTrip.additional_information}
                          isScrollable={this.state.isAdditionalScrollable}
                        />
                      ) : null}
                      {(t('trip:cancellationPolicy') === additionalInfoArray[this.state.selectedAdditionalInfo].title) ? (
                        <ContentBlock
                          // title={t('trip:cancellationPolicy')}
                          description={mailto(
                            SDAC_EMAIL,
                            currentTrip.cancellation_policy
                          )}
                          isScrollable={this.state.isAdditionalScrollable}
                        />
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            )}
            {(!currentTrip.display_exp) ? (<TripTnc/>) : null}

            {(currentTrip.display_exp) ? (
              <div className='fe-past-experience-thank-you'>
                <div className='container'>
                  <div className='fe-past-experience-thank-you-text'>
                    Thank you for your interest. This experience is currently unavailable, but may be refreshed and open for booking in the future. Stay tuned!
                  </div>
                </div>
              </div>
            ): ((currentTrip.fully_book)?(
              <div className='fe-past-experience-thank-you'>
                <div className='container'>
                  <div className='fe-past-experience-thank-you-text'>
                    Thank you for your interest. This experience is fully booked now. Please click the 'Reserve a spot' button at the top of the page and leave your details for us to email you when we have the next date for the same event in the future.
                  </div>
                </div>
              </div>
            ):
              null)}
          </div>
      </>
    );
  }
}

TripDetails.propTypes = {
  trip: PropTypes.object,
  match: PropTypes.object.isRequired,
  currentTrip: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  error: PropTypes.object,
  fetchTripDetails: PropTypes.func.isRequired,
  setBookingAvailDates: PropTypes.func.isRequired,
  setBookingUnavailDates: PropTypes.func.isRequired,
  setBookingDate: PropTypes.func.isRequired,
  setBookingPax: PropTypes.func.isRequired,
  clearApiError: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired
};

const mapStateToProps = ({ tripDetailsState, bookingState, apiState }) => ({
  currentTrip: tripDetailsState.currentTrip,
  loading: tripDetailsState.loading,
  bookingDate: bookingState.date,
  bookingPax: bookingState.pax,
  error: apiState.error,
  isByAge: tripDetailsState.isByAge,
  tripPax: tripDetailsState.tripPax,
  byorSelected: tripDetailsState.byorSelected
});

const mapDispatchToProps = {
  fetchTripDetails,
  setBookingDate,
  setBookingPax,
  setBookingAvailDates,
  setBookingUnavailDates,
  clearApiError
};

export default withTranslation()(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(TripDetails)
);
